import { useTranslation } from "react-i18next";
import { Box, Chip, ListItem, ListItemButton, Typography } from "@mui/material";
import {
  RELATIVE_DAYS,
  formatRelativeDay,
} from "src/_modules/AiSupportChat/core/dates";
import { CONVERSATION_STATUS } from "src/_modules/AiSupportChat/core/protocol";

/** Finds the row buttons, so the list can move focus to one of them. */
export const ROW_SELECTOR = "[data-ai-conversation-row]";

/**
 * One previous conversation (plan §3.5): title on one line, relative date of
 * the last message, and a status chip («جارية» / «منتهية»).
 *
 * @param {object} props
 * @param {{ id: string, title?: string, status: string, lastMessageAt?: string }} props.conversation
 * @param {(id: string) => void} props.onOpen
 * @param {number} props.now render time, shared by all rows
 * @param {boolean} [props.disabled]
 */
export default function ConversationListItem({
  conversation,
  onOpen,
  now,
  disabled = false,
}) {
  const { t, i18n } = useTranslation("aiSupport");
  const isOpen = conversation.status === CONVERSATION_STATUS.OPEN;

  const day = formatRelativeDay(conversation.lastMessageAt, {
    now,
    lang: i18n.language,
  });
  const dayLabel =
    day === RELATIVE_DAYS.TODAY
      ? t("dates.today")
      : day === RELATIVE_DAYS.YESTERDAY
        ? t("dates.yesterday")
        : day;

  return (
    <ListItem disablePadding>
      <ListItemButton
        data-ai-conversation-row=""
        disabled={disabled}
        onClick={() => onOpen(conversation.id)}
        sx={{ gap: 1, borderRadius: 1, py: 1 }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="body2"
            noWrap
            dir="auto"
            // ListItemButton sets a physical `text-align: left`
            sx={{ textAlign: "start", fontWeight: 500 }}
          >
            {conversation.title || t("conversation.newTitle")}
          </Typography>
          {dayLabel && (
            <Typography
              variant="caption"
              color="text.secondary"
              component="time"
              dateTime={conversation.lastMessageAt}
              sx={{ display: "block", textAlign: "start" }}
            >
              {dayLabel}
            </Typography>
          )}
        </Box>
        <Chip
          size="small"
          variant="outlined"
          color={isOpen ? "success" : "default"}
          label={isOpen ? t("home.activeBadge") : t("home.closedBadge")}
          sx={{ flexShrink: 0 }}
        />
      </ListItemButton>
    </ListItem>
  );
}
